import { Star } from "lucide-react";
import { useFavorites } from "@/api/hooks";
import { DriveView, PageTitle } from "./DriveView";
import { EmptyState } from "./EmptyState";

/** Starred files and folders (formerly "Favourites"). */
export function FavoritesPage() {
    const favs = useFavorites();
    return (
        <DriveView
            variant="starred"
            label="Starred items"
            title={<PageTitle icon={Star} iconClass="fill-amber-400 text-amber-500">Starred</PageTitle>}
            query={favs}
            resetKey="starred"
            emptyState={
                <EmptyState
                    icon={Star}
                    tone="amber"
                    title="No starred files"
                    description="Add stars to things you want to find easily later — from the ☆ on any file or its menu."
                />
            }
        />
    );
}
